import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { HasProduct, withProduct } from "@insite/client-framework/Components/ProductContext";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import loadRealTimePricing from "@insite/client-framework/Store/CommonHandlers/LoadRealTimePricing";
import translate from "@insite/client-framework/Translate";
import { ProductModel } from "@insite/client-framework/Types/ApiModels";
import Button, { ButtonPresentationProps } from "@insite/mobius/Button";
import DynamicDropdown, { DynamicDropdownPresentationProps } from "@insite/mobius/DynamicDropdown";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import Img from "@insite/mobius/Img";
import LazyImage, { LazyImageProps } from "@insite/mobius/LazyImage";
import Link, { LinkPresentationProps } from "@insite/mobius/Link";
import Select, { SelectPresentationProps, SelectProps } from "@insite/mobius/Select";
import TextField, { TextFieldPresentationProps, TextFieldProps } from "@insite/mobius/TextField";
import ToasterContext from "@insite/mobius/Toast/ToasterContext";
import Typography, { TypographyProps } from "@insite/mobius/Typography";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import CustomGetQuoteOrderPage from "@tSurya/Components/CustomGetQuoteOrderPage";
import CustomRugQuoteForm from "@tSurya/Components/CustomRugQuoteForm";
import Constant from "@tSurya/Constants/Constant";
import customLoadRealTimePRicing from "@tSurya/Handlers/CustomLoadRealTimePRicing";
import sendCustomConfig from "@tSurya/Handlers/SelectCustomConfigHandler";
import submitCustomOrder from "@tSurya/Handlers/SendCustomHandler";
import { SelectCustomConfigApiParameter } from "@tSurya/Services/SelectCustomConfig";
import { CustomOrderApiParameter } from "@tSurya/Services/SendCustomOrder";
import { COLORS, TYPOGRAPHY } from "@tSurya/theme/design";
import React, { useContext } from "react";
import { connect, ResolveThunks } from "react-redux";
import { css } from "styled-components";

const mapStateToProps = (state: ApplicationState) => ({});

const mapDispatchToProps = {
    customLoadRealTimePRicing,
    submitCustomOrder,
    sendCustomConfig,
};

interface OwnProps {
    closeHandler?: any;
    productData: ProductModel;
}

type Props = OwnProps & ResolveThunks<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps> & HasProduct;
export interface GetQuoteForProductStyles {
    container?: GridContainerProps;
    gridItem?: GridItemProps;
    selectContainer?: InjectableCss;
    currentShapesContainer?: InjectableCss;
    shapeImageContainer?: LazyImageProps;
    shapeTitle?: TypographyProps;
    inputFieldContainer?: GridContainerProps;
    inputField?: GridItemProps;
    errorMsg?: TypographyProps;
    buttonContainer?: ButtonPresentationProps;
    placeOrderBtnContainer?: InjectableCss;
    note?: TypographyProps;
    noteList?: InjectableCss;
    placeOrderContainer?: GridContainerProps;
    customShapeLink?: LinkPresentationProps;
    selectShapes?: SelectProps;
    listStyle?: DynamicDropdownPresentationProps;
}

export const GetQuoteForProductStyles: GetQuoteForProductStyles = {
    gridItem: {
        width: [12, 12, 6, 6, 6],
        css: css`
            flex-direction: column;
        `,
    },
    selectContainer: {
        css: css`
            width: 100%;
            margin-bottom: 20px;
            display: flex;
            flex-direction: column;
        `,
    },
    shapeImageContainer: {
        css: css`
            margin: 0 auto;
            img {
                height: 250px;
            }
        `,
    },
    currentShapesContainer: {
        css: css`
            width: 100%;
        `,
    },
    shapeTitle: {
        css: css`
            font-weight: ${TYPOGRAPHY.weight.bold};
        `,
    },
    inputField: {
        width: [12, 12, 6, 6, 6],
        css: css``,
    },
    inputFieldContainer: {
        css: css`
            width: 100%;
            margin-bottom: 20px;
        `,
    },
    errorMsg: {
        css: css`
            color: red;
        `,
    },
    buttonContainer: {
        css: css`
            margin: 20px 0;
        `,
    },
    placeOrderBtnContainer: {
        css: css`
            margin-left: auto;
            align-self: flex-end;
        `,
    },
    placeOrderContainer: {
        css: css`
            margin-top: 30px;
            > div {
                > div {
                    ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                                flex-direction: column;
                            `,
                    css`
                                flex-direction: column;
                            `,
                    null,
                    null,
                    null,
                ])};
                }
            }
        `,
    },
    note: {
        variant: "h5",
    },
    noteList: {
        css: css`
            list-style: decimal;
            padding-left: 15px;
        `,
    },
    customShapeLink: {
        css: css`
           span {
                color: #866a5b !important;
            };
            text-decoration: underline;
            text-decoration-color:#866a5b;
        `,
    },
    selectShapes: {
        css: css``,
    },
};

const styles = GetQuoteForProductStyles;
const customRugs = "Minimum custom order is $500.00";
const includeFreight = "The provided quote does not include freight charges.";
const leadTimeEstimate = "Lead times are estimates and may vary.";
export interface ShapesInterface {
    Rectangle: string;
    Round: string;
    Square: string;
}

const shapes: ShapesInterface = {
    Rectangle: "staticContent/images/Rectangle.png",
    Round: "staticContent/images/Round.png",
    Square: "staticContent/images/Square.png",
};

const GetQuoteForProduct = ({
    productData,
    submitCustomOrder,
    closeHandler,
    sendCustomConfig,
    customLoadRealTimePRicing,
}: Props) => {
    const [placeOrder, setPlaceOrder] = React.useState(false);
    const [price, setPrice] = React.useState("");
    const [leadTime, setLeadTime] = React.useState("");
    const [acctualPrice, setacctualPrice] = React.useState("");

    const [showOrderPage, setShowOrderPage] = React.useState(false);
    const [showCustomOrderPage, setCustomOrderPage] = React.useState(false);
    const [shape, setShape] = React.useState(Object.values(shapes)[0]);
    const [currentShape, setCurrentShape] = React.useState(Object.keys(shapes)[0]);

    // square
    const [feet, setFeet] = React.useState<any>("");
    const [inches, setInches] = React.useState<any>("");
    const [errorMessage, setErrorMessage] = React.useState("");
    const toasterContext = useContext(ToasterContext);
    // reactangle
    const [widthFeet, setWidthFeet] = React.useState<any>("");
    const [widthInches, setWidthInches] = React.useState<any>("");
    const [lengthFeet, setLengthFeet] = React.useState<any>("");
    const [lengthInches, setLengthInches] = React.useState<any>("");
    const [error, setError] = React.useState("");

    // round
    const [roundfeet, setRoundFeet] = React.useState<any>("");
    const [roundinches, setRoundInches] = React.useState<any>("");
    const [roundErrorMessage, setRoundErrorMessage] = React.useState("");

    const maxWidthFeet = Number(productData.properties.masterDesignMaximumSizeWft) || null;
    const maxLengthFeet = Number(productData.properties.masterDesignMaximumSizeLft) || null;
    const maxSideFeet = Number(productData.properties.masterDesignMaximumSizeSideft) || null;
    const maxRoundSize = Number(productData.properties.masterDesignMaximumRoundSize) || null;

    const clearFields = () => {
        setFeet("");
        setInches("");
        setErrorMessage("");

        setWidthFeet("");
        setWidthInches("");
        setLengthFeet("");
        setLengthInches("");
        setError("");

        setRoundFeet("");
        setRoundInches("");
        setRoundErrorMessage("");
    };

    const calculateRectangleDimension = (event: any) => {
        event.preventDefault();

        if (
            (widthFeet === 0 && widthInches === 0) ||
            (widthFeet === "" && widthInches === 0) ||
            (widthFeet === "" && widthInches === "") ||
            (widthFeet === 0 && widthInches === "") ||
            widthFeet === null ||
            (widthFeet === 0 && widthInches === null)
        ) {
            setError("Minimum Width must be at least 1 ft/in");
            setPlaceOrder(false);
            return false;
        }

        if (
            (lengthFeet === 0 && lengthInches === 0) ||
            (lengthFeet === "" && lengthInches === 0) ||
            (lengthFeet === "" && lengthInches === "") ||
            (lengthFeet === 0 && lengthInches === "") ||
            lengthFeet === null ||
            (lengthFeet === 0 && lengthInches === null)
        ) {
            setError("Minimum Length must be at least 1 ft/in");
            setPlaceOrder(false);
            return false;
        }
        if (widthInches >= 12 || lengthInches >= 12) {
            setError("Inches may not exceed 11");
            setPlaceOrder(false);
            return false;
        }
        setError("");
        setPlaceOrder(true);
        customLoadRealTimePRicing({
            productPriceParameters: [
                {
                    productId: productData.id,
                    unitOfMeasure: productData.unitListPriceDisplay,
                    qtyOrdered: productData.minimumOrderQty || 1,
                    properties: {
                        Shape: currentShape,
                        LengthFeet: lengthFeet as unknown as string,
                        LengthInches: lengthInches as unknown as string,
                        WidthFeet: widthFeet as unknown as string,
                        WidthInches: widthInches as unknown as string,
                        // DiameterFeet:roundfeet  as unknown as string,
                        // DiameterInches:roundinches  as unknown as string,
                        // SideFeet:feet  as unknown as string,
                        // SideInches:inches  as unknown as string,
                    },
                },
            ],
            onSuccess: realTimePricing => {
                setPlaceOrder(true);
                setPrice(
                    realTimePricing.realTimePricingResults &&
                        realTimePricing.realTimePricingResults[0].additionalResults
                        ? realTimePricing.realTimePricingResults[0].additionalResults.calculatedPrice
                        : "",
                );
                setLeadTime(
                    realTimePricing.realTimePricingResults &&
                        realTimePricing.realTimePricingResults[0].additionalResults
                        ? realTimePricing.realTimePricingResults[0].additionalResults.customLeadtime
                        : "",
                );
                setacctualPrice(
                    realTimePricing.realTimePricingResults && realTimePricing.realTimePricingResults.length > 0
                        ? realTimePricing.realTimePricingResults[0].actualPriceDisplay
                        : "",
                );
            },
            onError: () => {
                setPlaceOrder(false);
            },
            onComplete(realTimePricingProps) {
                if (realTimePricingProps.apiResult) {
                    this.onSuccess?.(realTimePricingProps.apiResult);
                } else if (realTimePricingProps.error) {
                    this.onError?.(realTimePricingProps.error);
                }
            },
        });
        return true;
    };

    const handleSquareDimension = (event: any) => {
        event.preventDefault();
        if (
            (feet === 0 && inches === 0) ||
            (feet === "" && inches === 0) ||
            (feet === "" && inches === "") ||
            (feet === 0 && inches === "") ||
            feet === null ||
            (feet === 0 && inches === null)
        ) {
            setErrorMessage("Please enter required dimensions");
            setPlaceOrder(false);
            return false;
        }
        setErrorMessage("");
        // if (
        //     !props.productInfos ||
        //     props.productInfos.length === 0 ||
        //     (props.dataViewHasProducts && props.parameter.isShellEdit)
        // ) {
        //     return;
        // }

        customLoadRealTimePRicing({
            productPriceParameters: [
                {
                    productId: productData.id,
                    unitOfMeasure: productData.unitListPriceDisplay,
                    qtyOrdered: productData.minimumOrderQty || 1,
                    properties: {
                        Shape: currentShape,
                        SideFeet: feet as unknown as string,
                        SideInches: inches as unknown as string,
                    },
                },
            ],
            onSuccess: realTimePricing => {
                setPlaceOrder(true);
                setPrice(
                    realTimePricing.realTimePricingResults &&
                        realTimePricing.realTimePricingResults[0].additionalResults
                        ? realTimePricing.realTimePricingResults[0].additionalResults.calculatedPrice
                        : "",
                );
                setLeadTime(
                    realTimePricing.realTimePricingResults &&
                        realTimePricing.realTimePricingResults[0].additionalResults
                        ? realTimePricing.realTimePricingResults[0].additionalResults.customLeadtime
                        : "",
                );
                setacctualPrice(
                    realTimePricing.realTimePricingResults && realTimePricing.realTimePricingResults.length > 0
                        ? realTimePricing.realTimePricingResults[0].actualPriceDisplay
                        : "",
                );
            },
            onError: () => { },
            onComplete(realTimePricingProps) {
                if (realTimePricingProps.apiResult) {
                    this.onSuccess?.(realTimePricingProps.apiResult);
                } else if (realTimePricingProps.error) {
                    this.onError?.(realTimePricingProps.error);
                }
            },
        });
    };

    const handleRoundDimension = (event: any) => {
        event.preventDefault();
        if (
            (roundfeet === 0 && roundinches === 0) ||
            (roundfeet === "" && roundinches === 0) ||
            (roundfeet === "" && roundinches === "") ||
            (roundfeet === 0 && roundinches === "") ||
            roundfeet === null ||
            (roundfeet === 0 && roundinches === null)
        ) {
            setRoundErrorMessage("Please enter required dimensions");
            setPlaceOrder(false);
            return false;
        }
        setRoundErrorMessage("");
        customLoadRealTimePRicing({
            productPriceParameters: [
                {
                    productId: productData.id,
                    unitOfMeasure: productData.customerUnitOfMeasure,
                    qtyOrdered: productData.minimumOrderQty || 1,
                    properties: {
                        Shape: currentShape,
                        DiameterFeet: roundfeet as unknown as string,
                        DiameterInches: roundinches as unknown as string,
                    },
                },
            ],
            onSuccess: realTimePricing => {
                setPlaceOrder(true);
                setPrice(
                    realTimePricing.realTimePricingResults &&
                        realTimePricing.realTimePricingResults[0].additionalResults
                        ? realTimePricing.realTimePricingResults[0].additionalResults.calculatedPrice
                        : "",
                );
                setLeadTime(
                    realTimePricing.realTimePricingResults &&
                        realTimePricing.realTimePricingResults[0].additionalResults
                        ? realTimePricing.realTimePricingResults[0].additionalResults.customLeadtime
                        : "",
                );
                setacctualPrice(
                    realTimePricing.realTimePricingResults && realTimePricing.realTimePricingResults.length > 0
                        ? realTimePricing.realTimePricingResults[0].actualPriceDisplay
                        : "",
                );
            },
            onError: () => { },
            onComplete(realTimePricingProps) {
                if (realTimePricingProps.apiResult) {
                    this.onSuccess?.(realTimePricingProps.apiResult);
                } else if (realTimePricingProps.error) {
                    this.onError?.(realTimePricingProps.error);
                }
            },
        });
    };

    const customOrderPage = (e: any) => {
        e.preventDefault();
        setShowOrderPage(false);
        setCustomOrderPage(true);
    };

    const handleSelectChange: SelectProps["onChange"] = event => {
        clearFields();
        setPlaceOrder(false);
        Object.entries(shapes).forEach(([key, value]) => {
            if (`${key}` === `${event.target.value}`) {
                setShape(value);
                setCurrentShape(key);
            }
        });
    };

    const showOrderDetailsPage = () => {
        setShowOrderPage(true);
    };

    // const customConfigSender = () => {
    //     sendCustomConfig({
    //         ...customConfigParams,
    //         onComplete(result) {
    //             closeHandler();
    //             toasterContext.addToast({
    //                 body: translate(`Order Submitted Successfully`),
    //                 messageType: "success",
    //             });
    //         },
    //     });
    // };

    const feetValidationsOnChnage = (e: React.ChangeEvent<HTMLInputElement>) => {
        const value = e.target.value;
            if (currentShape === "Rectangle") {
                if (value === "") {
                    setWidthFeet(value);
                    setError("");
                    return;
                }
                Validations(setWidthFeet, Number(value));
            } else if (currentShape === "Square") {
                if (value === "") {
                    setFeet(value);
                    setError("");
                    return;
                }
                Validations(setFeet, Number(value));
            } else if (currentShape === "Round") {
                if (value === "") {
                    setRoundFeet(value);
                    setError("");
                    return;
                }
                Validations(setRoundFeet, Number(value));
            }
    };
    const restrictInputToNumbers = (e: React.KeyboardEvent<HTMLInputElement>) => {
        const invalidKeys = ["e", "E", ".", "-", "+"];
    
        if (invalidKeys.includes(e.key)) {
            e.preventDefault();
        }
    };

    const Validations = (state: any, value: number) => {
        if (currentShape === "Rectangle") {
            if (maxWidthFeet) {
                if (parseFloat(`${value}.${widthInches}`) > maxWidthFeet) {
                    setError(`Maximum Width may not exceed ${maxWidthFeet} ft'`);
                    setPlaceOrder(false);
                    return false;
                }
            }
        } else if (currentShape === "Square") {
            if (maxSideFeet) {
                if (parseFloat(`${value}.${inches}`) > maxSideFeet) {
                    setErrorMessage(`Maximum side may not exceed ${maxSideFeet} ft'`);
                    setPlaceOrder(false);
                    return;
                }
            }
        } else if (currentShape === "Round") {
            if (maxRoundSize) {
                if (parseFloat(`${value}.${roundinches}`) > maxRoundSize) {
                    setRoundErrorMessage(`Maximum diameter may not exceed ${maxRoundSize} ft'`);
                    setPlaceOrder(false);
                    return;
                }
            }
        }
        setError("");
        state(value);
    };

    const inchesValidationsOnChnage = (e: React.ChangeEvent<HTMLInputElement>) => {
        const value = e.target.value;

        if (currentShape === "Rectangle") {
            if (value === "") {
                setWidthInches(value);
                setError("");
                return;
            }
            inchesValidation(setWidthInches, Number(value));
        } else if (currentShape === "Square") {
            if (value === "") {
                setInches(value);
                setError("");
                return;
            }
            inchesValidation(setInches, Number(value));
        } else if (currentShape === "Round") {
            if (value === "") {
                setRoundInches(value);
                setError("");
                return;
            }
            inchesValidation(setRoundInches, Number(value));
        }
    };

    const inchesValidation = (state: any, value: number) => {
        if (currentShape === "Rectangle") {
            if (value > 11) {
                setError("Maximum value for inch is 11");
                setPlaceOrder(false);
                return;
            }
            if (maxWidthFeet) {
                if (parseFloat(`${widthFeet}.${value}`) > maxWidthFeet) {
                    setError(`Maximum Width may not exceed ${maxWidthFeet} ft'`);
                    setPlaceOrder(false);
                    return;
                }
            }
        } else if (currentShape === "Square") {
            if (value > 11) {
                setErrorMessage("Maximum value for inch is 11");
                setPlaceOrder(false);
                return;
            }
            if (maxSideFeet) {
                if (parseFloat(`${feet}.${value}`) > maxSideFeet) {
                    setErrorMessage(`Maximum side may not exceed ${maxSideFeet} ft'`);
                    setPlaceOrder(false);
                    return;
                }
            }
        } else if (currentShape === "Round") {
            if (value > 11) {
                setRoundErrorMessage("Maximum value for inch is 11");
                setPlaceOrder(false);
                return;
            }
            if (maxRoundSize) {
                if (parseFloat(`${roundfeet}.${value}`) > maxRoundSize) {
                    setRoundErrorMessage(`Maximum diameter may not exceed ${maxRoundSize} ft'`);
                    setPlaceOrder(false);
                    return;
                }
            }
        }
        setError("");
        state(value);
    };
    const lengthinchesValidation = (e: React.ChangeEvent<HTMLInputElement>) => {
        const value = e.target.value;
        if (value === "") {
            setLengthInches(value);
            setError("");
            return;
        }
        if (parseFloat(value) > 11) {
            setError("Maximum value for inch is 11");
            setPlaceOrder(false);
            return;
        }
        if (maxLengthFeet) {
            if (parseFloat(`${lengthFeet}.${value}`) > maxLengthFeet) {
                setError(`Maximum Length may not exceed ${maxLengthFeet} ft'`);
                setPlaceOrder(false);
                return false;
            }
        }
        setError("");
        setLengthInches(value);
    };
    const lengthValidation = (e: React.ChangeEvent<HTMLInputElement>) => {
        const value = e.target.value;
        if (value === "") {
            setLengthFeet(value);
            setError("");
            return;
        }
        if (maxLengthFeet) {
            if (parseFloat(`${value}.${lengthInches}`) > maxLengthFeet) {
                setError(`Maximum Length may not exceed ${maxLengthFeet} ft'`);
                setPlaceOrder(false);
                return false;
            }
        }
        setError("");
        setLengthFeet(value);
    };
    return (
        <StyledWrapper>
            {showCustomOrderPage ? (
                <CustomRugQuoteForm
                    feet={feet}
                    inch={inches}
                    roundfeet={roundfeet}
                    roundinch={roundinches}
                    widthFeet={widthFeet}
                    widthInch={widthInches}
                    selectedShape={currentShape}
                    lengthFeet={lengthFeet}
                    lengthInches={lengthInches}
                    product={productData}
                    currentShape={currentShape}
                    price={price}
                    closeHandler={closeHandler}
                />
            ) : !showOrderPage ? (
                <>
                    <GridContainer {...styles.container}>
                        <GridItem {...styles.gridItem}>
                            <StyledWrapper {...styles.selectContainer}>
                                <Typography {...styles.shapeTitle} as="p">
                                    Shape:
                                </Typography>
                                <Select onChange={handleSelectChange} {...styles.selectShapes}>
                                    <option value="Rectangle">Rectangle</option>
                                    <option value="Square">Square</option>
                                    {productData?.properties?.masterDesignPossibleinRoundSize?.toLowerCase() ===
                                        "true" && <option value="Round">Round</option>}
                                </Select>
                            </StyledWrapper>
                            <StyledWrapper>
                                {currentShape === "Rectangle" && (
                                    <StyledWrapper {...styles.currentShapesContainer}>
                                        <Typography>Width:</Typography>
                                        <GridContainer {...styles.inputFieldContainer}>
                                            <GridItem {...styles.inputField}>
                                                <TextField
                                                    type="number"
                                                    placeholder={translate("ft")}
                                                    value={widthFeet}
                                                    min={0}
                                                    // eslint-disable-next-line radix
                                                    onChange={feetValidationsOnChnage}
                                                    onKeyDown={restrictInputToNumbers}
                                                />
                                            </GridItem>
                                            <GridItem {...styles.inputField}>
                                                <TextField
                                                    type="number"
                                                    placeholder={translate("in")}
                                                    value={widthInches}
                                                    min={0}
                                                    // eslint-disable-next-line radix
                                                    onChange={inchesValidationsOnChnage}
                                                    onKeyDown={restrictInputToNumbers}
                                                />
                                            </GridItem>
                                        </GridContainer>

                                        <Typography>Length:</Typography>
                                        <GridContainer {...styles.inputFieldContainer}>
                                            <GridItem {...styles.inputField}>
                                                <TextField
                                                    type="number"
                                                    placeholder={translate("ft")}
                                                    value={lengthFeet}
                                                    min={0}
                                                    // eslint-disable-next-line radix
                                                    onChange={lengthValidation}
                                                    onKeyDown={restrictInputToNumbers}
                                                />
                                            </GridItem>
                                            <GridItem {...styles.inputField}>
                                                <TextField
                                                    type="number"
                                                    placeholder={translate("in")}
                                                    value={lengthInches}
                                                    min={0}
                                                    // eslint-disable-next-line radix
                                                    onChange={lengthinchesValidation}
                                                    onKeyDown={restrictInputToNumbers}
                                                />
                                            </GridItem>
                                        </GridContainer>
                                        <Button {...styles.buttonContainer} onClick={calculateRectangleDimension}>
                                            Calculate
                                        </Button>
                                        {error && (
                                            <Typography variant="p" {...styles.errorMsg}>
                                                {error}
                                            </Typography>
                                        )}
                                    </StyledWrapper>
                                )}
                                {currentShape === "Square" && (
                                    <StyledWrapper {...styles.currentShapesContainer}>
                                        <Typography>Side:</Typography>
                                        <GridContainer {...styles.inputFieldContainer}>
                                            <GridItem {...styles.inputField}>
                                                <TextField
                                                    type="number"
                                                    placeholder={translate("ft")}
                                                    value={feet}
                                                    min={0}
                                                    // eslint-disable-next-line radix
                                                    onChange={feetValidationsOnChnage}
                                                    onKeyDown={restrictInputToNumbers}
                                                />
                                            </GridItem>
                                            <GridItem {...styles.inputField}>
                                                <TextField
                                                    type="number"
                                                    placeholder={translate("in")}
                                                    value={inches}
                                                    min={0}
                                                    // eslint-disable-next-line radix
                                                    onChange={inchesValidationsOnChnage}
                                                    onKeyDown={restrictInputToNumbers}
                                                />
                                            </GridItem>
                                        </GridContainer>
                                        <StyledWrapper>
                                            <Button {...styles.buttonContainer} onClick={handleSquareDimension}>
                                                Calculate
                                            </Button>
                                        </StyledWrapper>
                                        {errorMessage && (
                                            <Typography variant="p" {...styles.errorMsg}>
                                                {errorMessage}
                                            </Typography>
                                        )}
                                    </StyledWrapper>
                                )}
                                {currentShape === "Round" && (
                                    <StyledWrapper {...styles.currentShapesContainer}>
                                        <Typography>Diameter:</Typography>
                                        <GridContainer {...styles.inputFieldContainer}>
                                            <GridItem {...styles.inputField}>
                                                <TextField
                                                    type="number"
                                                    placeholder={translate("ft")}
                                                    value={roundfeet}
                                                    min={0}
                                                    // eslint-disable-next-line radix
                                                    onChange={feetValidationsOnChnage}
                                                    onKeyDown={restrictInputToNumbers}
                                                />
                                            </GridItem>
                                            <GridItem {...styles.inputField}>
                                                <TextField
                                                    type="number"
                                                    placeholder={translate("in")}
                                                    value={roundinches}
                                                    min={0}
                                                    // eslint-disable-next-line radix
                                                    onChange={inchesValidationsOnChnage}
                                                    onKeyDown={restrictInputToNumbers}
                                                />
                                            </GridItem>
                                        </GridContainer>

                                        <Button {...styles.buttonContainer} onClick={handleRoundDimension}>
                                            Calculate
                                        </Button>
                                        {roundErrorMessage && (
                                            <Typography variant="p" {...styles.errorMsg}>
                                                {roundErrorMessage}
                                            </Typography>
                                        )}
                                    </StyledWrapper>
                                )}
                                {!(productData.productNumber.toLowerCase().endsWith(Constant.customProduct) &&
                                    productData.properties.productType === Constant.customProductType) &&
                                    <StyledWrapper>
                                        <Link onClick={customOrderPage} {...styles.customShapeLink}>
                                            Don't see the shape you're looking for?
                                        </Link>
                                    </StyledWrapper>}
                            </StyledWrapper>
                        </GridItem>
                        <GridItem {...styles.gridItem}>
                            <LazyImage src={shape} {...styles.shapeImageContainer}></LazyImage>
                        </GridItem>
                    </GridContainer>
                    {placeOrder ? (
                        <GridContainer {...styles.placeOrderContainer}>
                            <GridItem width={12}>
                                <StyledWrapper>
                                    <Typography {...styles.note}>
                                        Price: {`$${price?.replace(/\B(?=(\d{3})+(?!\d))/g, ",")}`}
                                    </Typography>
                                    <Typography {...styles.note}>Lead Time: {leadTime}</Typography>
                                    <Typography {...styles.note}>Please note the following:</Typography>
                                    <ul {...styles.noteList}>
                                        <li>
                                            {!(
                                                productData.productNumber
                                                    .toLowerCase()
                                                    .endsWith(Constant.customProduct) &&
                                                productData.properties.productType === Constant.customProductType
                                            ) && customRugs}
                                        </li>
                                        <li>{includeFreight}</li>
                                        <li>{leadTimeEstimate}</li>
                                    </ul>
                                </StyledWrapper>
                                {!(productData.productNumber.toLowerCase().endsWith(Constant.customProduct) &&
                                    productData.properties.productType === Constant.customProductType) &&
                                    <StyledWrapper {...styles.placeOrderBtnContainer}>
                                        <Button {...styles.buttonContainer} onClick={showOrderDetailsPage}>
                                            Place Order
                                        </Button>
                                    </StyledWrapper>}
                            </GridItem>
                        </GridContainer>
                    ) : null}
                </>
            ) : (
                <CustomGetQuoteOrderPage
                    feet={feet}
                    inch={inches}
                    roundfeet={roundfeet}
                    roundinch={roundinches}
                    widthFeet={widthFeet}
                    widthInch={widthInches}
                    selectedShape={currentShape}
                    lengthFeet={lengthFeet}
                    lengthInches={lengthInches}
                    product={productData}
                    currentShape={currentShape}
                    price={price}
                    closeHandler={closeHandler}
                    leadTime={leadTime}
                    acctualPrice={acctualPrice}
                />
            )}
        </StyledWrapper>
    );
};

export default withProduct(connect(mapStateToProps, mapDispatchToProps)(GetQuoteForProduct));
